import React from 'react';
import Icon from '../../../components/AppIcon';

const ContractOverviewCard = ({ title, value, icon, color, subtitle }) => {
  const colorClasses = {
    green: 'from-green-500 to-green-600 text-green-600 bg-green-50',
    amber: 'from-amber-500 to-amber-600 text-amber-600 bg-amber-50',
    blue: 'from-blue-500 to-blue-600 text-blue-600 bg-blue-50',
    red: 'from-red-500 to-red-600 text-red-600 bg-red-50'
  };

  const [gradientClass, textClass, bgClass] = colorClasses?.[color]?.split(' ') || colorClasses?.blue?.split(' ');

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-5 hover:shadow-lg transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className={`p-2.5 bg-gradient-to-br ${gradientClass} rounded-lg shadow-sm`}>
          <Icon name={icon} className="h-6 w-6 text-white" />
        </div>
      </div>
      <div className="space-y-1">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <p className={`text-3xl font-bold ${textClass}`}>{value}</p>
        <p className="text-xs text-gray-500">{subtitle}</p>
      </div>
    </div>
  );
};

export default ContractOverviewCard;